const ResumeApi = [
    {
      id: 1,
      category: "education",
      year: "Courses (Jul 2021 - Apr 2022)",
      title: "PLATZI",
      desc1: "- Frontend Developer Theoretical and Practical Course.",
      desc2: "- JS Theoretical and Practical Professional Course.",
      desc3: "- Introductory React.js Course.",
      desc4: "- Responsive Design Course - Mobile First Layout",
      desc5: "- EcmaScript 6+ Course",
      rate: "4.30/5",
    },
    {
      id: 2,
      category: "education",
      year: "Courses (Apr 2021) ",
      title: "FREECODECAMP",
      desc1: "- Responsive Web Design.",
      rate: "4.50/5",
    },
    {
      id: 3,
      category: "education",
      year: "Courses (2019 - 2020)",
      title: "GOOGLE ACTIVATE",
      desc1: "- Protect your business: Cyber Safety at work.",
      desc2: "- Big Data Fundamentals.",
      desc3: "- Cloud Computing.",
      rate: "4.80/5 ",
    },
    {
      id: 4,
      category: "experience",
      year: "Factoring Prestamype (Sep 2022 - actually) ",
      title: "FRONTEND DEVELOPER",
      desc1: "- Layout of the different components that require a web application with React js.",
      desc2: "- Use APIs to connect the web with services.",
      desc3: "- Responsive Design.",
      rate: "5.00/5 ",
    },
    {
      id: 5,
      category: "experience",
      year: "Divelia Studio S.A.C. (May 2021 - Jan 2022) ",
      title: "FRONTEND AND CMS DEVELOPER",
      desc1: "- Layout of the different components that require a web application with React js.",
      desc2: "- Use APIs to connect the web with services.",
      desc3: "- Responsive Design.",
      rate: "4.70/5 ",
    },
    {
      id: 6,
      category: "experience",
      year: "Lavaquick Express S.A. (Jul 2020 - Sep 2020) ",
      title: "FULL STACK DEVELOPER",
      desc1: "- In charge of the Backend and development in PHP with Laravel.",
      desc2: "- In charge of the Frontend and development with Bootstrap.",
      rate: "4.95/5 ",
    },
  ]
  
  export default ResumeApi